<template>
  <div class="detail-wrap">
    <el-form ref="tenant" :rules="rules" :model="tenant" :inline-message="true" class="demo-ruleForm">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}购买渠道
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button v-if="(buyChannelSave && formData.id == null) || (buyChannelEdit && formData.id != null)" type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <!-- <b>创建工单</b> -->
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  购买渠道名称
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-input type="text" maxlength="10" autocomplete="off" v-model="formData.buyChannelName" clearable/>
                  </div>
                </td>

                <th>
                  是否在微信中显示
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-select v-model="formData.isShowwx">
                      <el-option label="否" :value="0"/>
                      <el-option label="是" :value="1"/>
                    </el-select>
                  </div>
                </td>

                <th v-if="formData.isShowwx == 1">
                  <em class="f-red">*</em>
                  购买渠道别名
                </th>
                <td class="table-row" v-if="formData.isShowwx == 1">
                  <div class="table-cell">
                    <el-input type="text" maxlength="10" autocomplete="off" v-model="formData.wxBuyChannelName" clearable
                    @blur="inspection"/>
                  </div>
                </td>

                <th>
                  是否在发布中显示
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-select v-model="formData.isShowIssue">
                      <el-option label="否" :value="0"/>
                      <el-option label="是" :value="1"/>
                    </el-select>
                  </div>

                </td>

                <th>
                  是否在自建中显示
                </th>
                <td class="table-row">
                  <el-select v-model="formData.isShowSiteIssue">
                    <el-option label="否" :value="0"/>
                    <el-option label="是" :value="1"/>
                  </el-select>
                </td>
              </tr>
              <tr>
                <th>编码</th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-input type="text" maxlength="10" autocomplete="off" v-model="formData.code" clearable/>
                  </div>
                </td>

                <th>排序</th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-input type="number" min="0" max="99" autocomplete="off" v-model="formData.seq" clearable/>
                  </div>
                </td>


                <th>
                  派单合并大类
                </th>
                <td>
                  <el-select v-model="formData.paidanHebingDaleiName"
                             @change="selectHebingDalei">
                    <el-option v-for="item in paidanHebingDaleiOption" :key="item.id" :label="item.label"
                               :value="{ value: item.id, label: item.label }" />
                  </el-select>
                </td>

              </tr>
              </tbody>
            </table>
          </div>
          <div>
          </div>
        </div>
      </div>
    </el-form>

  </div>
</template>
<script>
import api from "@/api/projectApi";
import {mapGetters} from "vuex";
import {loadDictData} from "@/config/dictType";

export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    initTableList: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      buyChannelSave: false,
      buyChannelEdit: false,

      paidanHebingDaleiOption:[],//合并大类下拉框
      formData: {
        id: null,
        buyChannelName: null,  // 购买渠道名称,同厂商下惟一
        wxBuyChannelName: null,// 别名
        isShowwx: 0,  // 是否在微信中显示:0否1是
        isShowIssue: 1,  // 是否在发布中显示:0否1是
        isShowSiteIssue: 0,  // 是否在自建中显示:0否1是
        seq: 0,  // 排序
        code: null,
      },

      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.tenant,"tenant的值");
  },
  mounted() {
    this.buyChannelEdit = this.permissions['buy_channel_edit']
    this.buyChannelSave = this.permissions['buy_channel_add']
    this.getData()
    this.loadHebingDaleiData()
  },
  methods: {
    // 加载数据字典中购买渠道合并大类
    loadHebingDaleiData() {
      loadDictData("购买渠道合并大类").then(res => {
        this.paidanHebingDaleiOption = []
        res.data.data.forEach(item => {
          this.paidanHebingDaleiOption.push({
            label: item.label,
            id: item.id
          })
        })
      })
    },
    //获取购买渠道合并大类名称
    selectHebingDalei(data) {
      this.formData.paidanHebingDaleiId = data.value;
      this.formData.paidanHebingDaleiName = data.label;
    },
    inspection() {
      if (this.formData.buyChannelName) {
        this.$http({
          url: api.basBuyChannel.inspectionUrl,
          method: 'post',
          data: {
            value: this.formData.buyChannelName,
            id: this.formData.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("购买渠道名称已存在，请重新输入")
            this.formData.buyChannelName = null
          }
        })
      }
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.basBuyChannel.getDataUrl,
          method: 'post',
          data: {
            id: this._dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data;
        })
      }
    },

    saveData() {
      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$mask.open()

        var url = this.isEdit ? api.basBuyChannel.updateDataUrl : api.basBuyChannel.addDataUrl
        this.$http({
          url: url,
          method: `post`,
          data: this.formData,
          isLoading: true,
        }).then(() => {
          this.$message.success("保存成功！");
          this.reload()
          this.$mask.close()

        }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });

      });
    }
  },
};

</script>
<style lang="scss" scoped>
// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.table-row {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.table-cell {
  flex: 1;
  margin-right: 10px;
}

</style>
